import { useTranslation } from "react-i18next"

export default function Form({ form, title, children, onSubmit, decorateless, icon }) {

    const { t } = useTranslation()

    title = title || ''

    const Title = () => {
        if (icon) {
            return (
                <i className={"flex align-items-center mb-4 fadein " + icon} style={{ fontSize: '1.5rem' }}>
                    <div className={title ? "ml-2" : ""} style={{ fontSize: '1rem' }}>{t(title)}</div>
                </i>
            )
        }
        return (
            <div className={title ? "mb-4" : ""}>{t(title)}</div>
        )
    }

    if (form) {

        return (
            <div id="formCrud" className={(decorateless ? "" : "form-shape") + " col-12"}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    {Title()}
                    {children}
                </form>
            </div>
        )
    }

    return (
        <div id="formCrud" className={(decorateless ? "" : "form-shape") + " col-12"}>
            {Title()}
            {children}
        </div>
    )

}
